function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 7,
  x2: 15,
  y2: 7,
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 10,
  x2: 12,
  y2: 10,
  stroke: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4 14.5H4.5C4.5 14.3674 4.44732 14.2402 4.35355 14.1464C4.25979 14.0527 4.13261 14 4 14V14.5ZM4 15.738H3.5H4ZM5.76822 16.3781L6.15233 16.6982H6.15233L5.76822 16.3781ZM7.33333 14.5V14C7.18494 14 7.04422 14.0659 6.94922 14.1799L7.33333 14.5ZM2.5 5.5C2.5 4.67157 3.17157 4 4 4V3C2.61929 3 1.5 4.11929 1.5 5.5H2.5ZM2.5 12.5V5.5H1.5V12.5H2.5ZM4 14C3.17157 14 2.5 13.3284 2.5 12.5H1.5C1.5 13.8807 2.61929 15 4 15V14ZM3.5 14.5L3.5 15.738H4.5L4.5 14.5H3.5ZM3.5 15.738C3.5 17.1409 5.25419 17.776 6.15233 16.6982L5.38411 16.058C5.08473 16.4173 4.5 16.2056 4.5 15.738H3.5ZM6.15233 16.6982L7.71744 14.8201L6.94922 14.1799L5.38411 16.058L6.15233 16.6982ZM16 14H7.33333V15H16V14ZM17.5 12.5C17.5 13.3284 16.8284 14 16 14V15C17.3807 15 18.5 13.8807 18.5 12.5H17.5ZM17.5 5.5V12.5H18.5V5.5H17.5ZM16 4C16.8284 4 17.5 4.67157 17.5 5.5H18.5C18.5 4.11929 17.3807 3 16 3V4ZM4 4H16V3H4V4Z",
  fill: "black"
});

var SvgReviews = function SvgReviews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReviews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reviews.ff9243a7.svg";
export { ForwardRef as ReactComponent };